module.exports = __webpack_public_path__ + "static/media/sales-stream-crying.9831f5f7.svg";